<common-ui-components-page-layout
  [title]="'جستجو'"
  [showBorder]="false"
>
  <div class="surface-high-contrast hub-search d-flex flex-column align-items-stretch justify-content-start w-100 stores-search">
    <div class="px-plus stores-search-box surface-high-contrast py-plus">
      <common-ui-components-search
        [mode]="'section'"
        (searchTextChange)="doSearch($event)"
        (searchEnd)="searchEnd($event)"
        [placeHolder]="'جستجو در فروشگاه‌ها'"
        [(searchText)]="searchText"
        #searchComponent
      ></common-ui-components-search>
    </div>
    @if (searching() || searched()) {
      <div class="px-plus pb-plus d-flex flex-column align-items-stretch justify-content-start gap-minus flex-grow">
        @if (searching()) {
          @for (item of rangeCreator(3); track $index) {
            <daily-stores-store-preview
              [mode]="'horizontal-small'"
              [isLoading]="true"
            ></daily-stores-store-preview>
          }
        } @else {
          @if (showingStores().length) {
            @for (store of showingStores(); track $index) {
              <daily-stores-store-preview
                (click)="handleStoreClick(store)"
                [mode]="'horizontal-small'"
                [store]="store"
                [classes]="'cursor-pointer'"
              ></daily-stores-store-preview>
            }
            <div class="w-100 border-t-300 border-color-air"></div>
          }
          @if (showingSuggestions().length) {
            @for (suggestion of showingSuggestions(); track $index) {
              <div
                class="d-flex align-items-center justify-content-start gap-minus cursor-pointer"
                (click)="suggestionClick(suggestion)"
              >
                <div class="d-flex align-items-center justify-content-center surface-back radius-rounded p-small">
                  <common-icon-dp-icon
                    [icon]="'search'"
                    [iconType]="'linear'"
                    [iconSize]="'20'"
                  ></common-icon-dp-icon>
                </div>
                <div class="c-2 text-onback-medium">جستجوی {{ suggestion }}</div>
              </div>
            }
          } @else {
            <div
              class="d-flex align-items-center justify-content-start gap-minus cursor-pointer"
              (click)="suggestionClick(searchText())"
            >
              <div class="d-flex align-items-center justify-content-center surface-back radius-rounded p-small">
                <common-icon-dp-icon
                  [icon]="'search'"
                  [iconType]="'linear'"
                  [iconSize]="'20'"
                ></common-icon-dp-icon>
              </div>
              <div class="c-2 text-onback-medium">{{ ctaSearchText() }}</div>
            </div>
          }
        }
      </div>
    } @else if (totalSearching() || totalSearched()) {
      <div class="d-flex pb-plus flex-column align-items-start justify-content-start gap-plus flex-grow w-100">
        @if (totalSearching() || totalStores().length) {
          <div class="w-100">
            <div class="px-plus">
              <common-ui-components-title-summary
                [isLoading]="totalSearching()"
                [title]="'فروشگاه‌ها'"
                [showButton]="false"
                [wrapperClasses]="'mb-small'"
              ></common-ui-components-title-summary>
            </div>
            <common-ui-components-horizontal-scroll [classes]="'pr-plus'">
              @if (totalSearching()) {
                @for (item of rangeCreator(4); track $index) {
                  <daily-stores-store-preview [isLoading]="true"></daily-stores-store-preview>
                }
              } @else {
                @for (store of totalStores(); track $index) {
                  <daily-stores-store-preview
                    (click)="handleStoreClick(store)"
                    [store]="store"
                    [classes]="'cursor-pointer'"
                  ></daily-stores-store-preview>
                }
              }
            </common-ui-components-horizontal-scroll>
          </div>
        }
        @if (totalSearching() || totalProducts().length || isPriceFilterModified()) {
          <div class="w-100">
            <div class="px-plus">
              <common-ui-components-title-summary
                [isLoading]="totalSearching()"
                [title]="'محصولات'"
                [showButton]="false"
                [wrapperClasses]="'mb-small'"
              ></common-ui-components-title-summary>
            </div>
            <div class="px-plus my-minus">
              <daily-stores-products-sort-and-filter></daily-stores-products-sort-and-filter>
            </div>
            <div class="d-flex flex-column gap-small">
              @if (totalProducts().length) {
                <div
                  class="px-plus w-100 stores-search-total-products gap-small"
                  commonUtilitiesScrolledToEnd
                  (scrolledToEnd)="handleNewPage()"
                >
                  @for (product of totalProducts(); track $index) {
                    <daily-stores-product-preview
                      [queryId]="queryId()"
                      [position]="$index"
                      [backgroundMode]="'back'"
                      [product]="product"
                      [classes]="'cursor-pointer'"
                      (clicked)="handleProductClick($event)"
                    ></daily-stores-product-preview>
                  }
                </div>
              }
              @if (totalSearching()) {
                <div class="px-plus w-100 stores-search-total-products gap-small">
                  @for (item of rangeCreator(3); track $index) {
                    <daily-stores-product-preview [isLoading]="true"></daily-stores-product-preview>
                  }
                </div>
              } @else if (!totalProducts().length) {
                <div class="flex-grow w-100 d-flex align-items-center justify-content-center">
                  <common-ui-components-no-item></common-ui-components-no-item>
                </div>
              }
            </div>
          </div>
        }
        @if (!totalProducts().length && !totalStores().length && !totalSearching()) {
          <div class="flex-grow w-100 d-flex align-items-center justify-content-center">
            <common-ui-components-no-item></common-ui-components-no-item>
          </div>
        }
      </div>
    } @else {
      <div
        class="pb-plus px-atom"
        [ngClass]="{ 'd-none': !hasHistory() }"
      >
        <stores-applet-search-history
          (hasHistory)="handleHasHistory($event)"
          (itemClicked)="suggestionClick($event)"
        ></stores-applet-search-history>
      </div>
      <div class="pb-plus px-atom">
        <stores-applet-suggested-searches (itemClicked)="suggestionClick($event)"></stores-applet-suggested-searches>
      </div>
      <div class="pb-plus px-atom">
        <stores-applet-popular-stores (itemClicked)="handleStoreClick($event)"></stores-applet-popular-stores>
      </div>
      <div class="pb-plus px-atom">
        <stores-applet-categories-mini-view [backgroundClass]="'surface-back'"></stores-applet-categories-mini-view>
      </div>
    }
  </div>
</common-ui-components-page-layout>
